module.exports = __webpack_public_path__ + "static/table5-59e599378744b30bde43a32a41d92576.jpg";